import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout/Layout';
import { PrivateRoute } from './components/auth/PrivateRoute';
import { Home } from './pages/Home';
import { Papers } from './pages/Papers';
import { Subscription } from './pages/Subscription';
import { Reports } from './pages/Reports';
import { AuthPage } from './pages/auth/AuthPage';
import { VerifyPage } from './pages/auth/VerifyPage';
import { SlackSuccess } from './pages/auth/SlackSuccess';
import { AuthProvider } from './context/AuthContext';
import { MyReports } from './pages/MyReports';
import { ExportReport } from './pages/ExportReport';
import { DevDocs } from './pages/DevDocs';
import { TelegramReport } from './pages/TelegramReport';
import { RequestForm } from './components/telegram/RequestForm';
import { isTelegramWebApp } from './hooks/useTelegram';
import './styles/telegram.css';

function App() {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    {/* Dev docs — 풀스크린, 별도 토큰 게이트 */}
                    <Route path="/dev" element={<DevDocs />} />

                    {/*
                      Telegram Mini App — 채팅 안에서 열렸을 때만 전용 화면으로 보낸다.
                      봇이 보내는 링크는 웹과 같은 /export/<hash> 이고, 같은 링크를
                      브라우저로 열면 기존 공유 페이지가 그대로 나온다.
                      Layout(헤더/사이드바) 밖에 두는 것이 핵심이다 — 시트 안에서는 잡음이다.
                    */}
                    {isTelegramWebApp() && (
                        <Route path="/export/:hash" element={<TelegramReport />} />
                    )}
                    {isTelegramWebApp() && (
                        <Route path="/tg/feedback" element={<RequestForm />} />
                    )}
                    {/* isTelegramWebApp() 은 렌더 시점에 평가된다. SDK 는 index.html 의
                        동기 스크립트라 React 번들보다 먼저 실행되므로 순서가 보장된다. */}

                    {/* 나머지 페이지 — Layout(헤더) 포함 */}
                    <Route
                        path="/*"
                        element={
                            <Layout>
                                <Routes>
                                    <Route path="/" element={<Home />} />
                                    <Route path="/papers" element={<Papers />} />
                                    <Route path="/auth" element={<AuthPage />} />
                                    <Route path="/auth/verify" element={<VerifyPage />} />
                                    <Route path="/auth/auto" element={<Navigate to="/" />} />
                                    <Route path="/auth/slack-success" element={<SlackSuccess />} />
                                    <Route path="/export/:hash" element={<ExportReport />} />
                                    <Route
                                        path="/subscription"
                                        element={
                                            <PrivateRoute>
                                                <Subscription />
                                            </PrivateRoute>
                                        }
                                    />
                                    <Route
                                        path="/reports"
                                        element={
                                            <PrivateRoute>
                                                <Reports />
                                            </PrivateRoute>
                                        }
                                    />
                                    <Route
                                        path="/my-reports"
                                        element={
                                            <PrivateRoute>
                                                <MyReports />
                                            </PrivateRoute>
                                        }
                                    />
                                </Routes>
                            </Layout>
                        }
                    />
                </Routes>
            </Router>
        </AuthProvider>
    );
}

export default App;